/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnOnce = exports.warn = exports.communityFeatureWarn = void 0;
var warn = function warn(msg) {
  console.warn("**************************************** INOVUA REACTDATAGRID COMMUNITY EDITION WARNING ****************************************\n\n                             ".concat(msg, "\n\n*********************************************************************************************************************************\n    "));
};
exports.warn = warn;
var onceMessages = {};
var warnOnce = function warnOnce(msg) {
  if (onceMessages[msg]) {
    return;
  }
  onceMessages[msg] = true;
  console.warn("**************************************** INOVUA REACTDATAGRID COMMUNITY EDITION WARNING ****************************************\n\n                             ".concat(msg, "\n\n*********************************************************************************************************************************\n    "));
};
exports.warnOnce = warnOnce;
var communityFeatureWarn = function communityFeatureWarn(featureName, checkObj) {
  if (checkObj[featureName]) {
    return;
  }
  checkObj[featureName] = true;
  warn("".concat(featureName, " is only supported in ENTERPRISE Edition, but you're using the Community Edition!"));
};
exports.communityFeatureWarn = communityFeatureWarn;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/warn.js
// module id = 274
// module chunks = 0